// extracted by mini-css-extract-plugin
export var orderSummary = "_qo-0";
export var showMoreLessButton = "_qo-1";